import API from './'

const library = {

	/**
	 * Get a list of libraries.
	 */
	list(params={}, config={})
	{
		let url = API.getUrl(`libraries`)

		return API.client().get(url, { params, ...config })
	},

	/**
	 * Get one library details.
	 */
	one(slug, params={}, config={})
	{
		let url = API.getUrl(`library/${slug}`)

		return API.client().get(url, { params, ...config })
	},

}

export default library